import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AppSettings } from '../app.settings';
import { CommonBindingDataService } from './common-binding-data.service';
import { RestApiService } from './rest-api.service';
import { environment } from 'src/environments/environment';
declare const google: any;
@Injectable({
  providedIn: 'root'
})
export class UserCommonService {
  private restApiService = inject(RestApiService);
  private commonBindingDataService = inject(CommonBindingDataService);

  message: any = {
    severity: '',
    summary: '',
    detail: ''
  };
  showMessageEvent = new Subject<any>();
  isShowMessage: Boolean = false;

  // getUserMetaDataInsecure(): Observable<any> {
  // return this.restApiService.get('/admin/metadata', 'page-center');
  // }

  toGMT(now:any) {
    return new Date(now.getTime() - (now.getTimezoneOffset() * 60000)).getTime();
  }

  toGMTTime(time:any) {
    const offset = new Date().getTimezoneOffset() * 60000;
    const gmtTime = time + offset
    if (gmtTime >= 0) {
      return gmtTime;
    } else {
      return ((24 * 3600000) + gmtTime - 1);
    }
  }

  toGMTTime1(time:any) {
    const offset = new Date().getTimezoneOffset() * 60000;
    const gmtTime = time + offset
    if (gmtTime >= 0) {
      return gmtTime;
    } else {
      return ((24 * 3600000) + gmtTime);
    }
  }


  toGMTTimeOnly(time:any) {
    const offset = new Date().getTimezoneOffset() * 60000;
    let gmtTime = time + offset;
    if (gmtTime >= 24 * 3600000) {
      gmtTime = gmtTime - 24 * 3600000;
    } if (gmtTime < 0) {
      gmtTime = 24 * 3600000 + gmtTime;
    }

    if (gmtTime > 0) {
      return gmtTime;
    } else if (gmtTime === 0) {
      return ((24 * 3600000) + gmtTime);
    } else {
      return ((24 * 3600000) + gmtTime - 1);
    }
  }



  toCurrentTime(time:any) {
    const offset = new Date().getTimezoneOffset() * 60000;
    const gmtTime = time - offset
    if (gmtTime >= 24 * 3600000) {
      return (gmtTime - 24 * 3600000);
    } else {
      return gmtTime;
    }
  }

  toLocalTime(miliSeconds:any) {
    const now = new Date(miliSeconds);
    return new Date(miliSeconds + now.getTimezoneOffset() * 60000).getTime();
  }

  toLocalDate(miliSeconds:any) {
    const now = new Date(miliSeconds);
    return new Date(miliSeconds + now.getTimezoneOffset() * 60000);
  }

  // getBookingDetails(): Observable<any> {
  //   return this.restApiService.get('/secure/booking/user/list/PASSENGER?offset=0&type=');
  // }

  getAdminUserMetaData() {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapApiKey}&language=en&libraries=visualization,places,geometry`;
      document.getElementsByTagName('head')[0].appendChild(script);


  }
  /**
   *
   * @param message : Message that want to show
   * @param type : Type of message Success,Warning and Error
   */
  showMessage(message: String, type: String = AppSettings.MESSAGE_TYPE.SUCCESS) {
    this.message = '';
    // Message display setting.
    const messageSetting : any = {
      severity: type,
      summary: '',
      detail: message
    };

    switch (type) {
      case AppSettings.MESSAGE_TYPE.SUCCESS:
        messageSetting.severity = AppSettings.MESSAGE_TYPE.SUCCESS;
        messageSetting.summary = this.commonBindingDataService.getLabel('msg_success_summary');
        break;
      case AppSettings.MESSAGE_TYPE.ERROR:
        messageSetting.severity = AppSettings.MESSAGE_TYPE.ERROR;
        messageSetting.summary = this.commonBindingDataService.getLabel('msg_error_summary');
        break;
      case AppSettings.MESSAGE_TYPE.WARNING:
        messageSetting.severity = AppSettings.MESSAGE_TYPE.WARNING;
        messageSetting.summary = this.commonBindingDataService.getLabel('msg_warning_summary');
        break;
      case AppSettings.MESSAGE_TYPE.INFO:
        messageSetting.severity = AppSettings.MESSAGE_TYPE.INFO;
        messageSetting.summary = this.commonBindingDataService.getLabel('msg_info_summary');
        break;
      default:
        messageSetting.severity = AppSettings.MESSAGE_TYPE.SUCCESS;
        messageSetting.summary = this.commonBindingDataService.getLabel('msg_success_summary');
        break;
    }
    // this.isShowMessage = true;
    this.message = messageSetting;
    this.showMessageEvent.next(this.message);
  }

  getGoogleMapAutoComplete(data: any): Observable<any> {
    return this.restApiService.post('google-autocomplete', `/secure/google-map/v2/autocomplete`, data, 'page-center');
  }

  getGoogleMapLatLng(placeId: any): Observable<any> {
    return this.restApiService.get('google-geocode', `/secure/google-map/geocode?placeId=${placeId}`, 'page-center');
  }

  getGoogleMapPlace(latLng: any): Observable<any> {
    return this.restApiService.get('google-reverse-geocode', `/secure/google-map/reverse-geocode?latLng=${latLng}`, 'page-center');
  }

  getGoogleMapRoute(data: any): Observable<any> {
    return this.restApiService.post('google-route', `/secure/google-map/v2/route`, data, 'page-center');
  }

  decodePolyline(encoded: string) {
    return google.maps.geometry.encoding.decodePath(encoded);
  }

}
